/** Site branding — change here to rebrand the whole app. */
export const BRAND = {
  name: 'KROWN1X',
  domain: 'krown1x.vip',
  /** Light wordmark, for dark backgrounds */
  logo: '/images/logo/krown1x.svg',
  /** Dark wordmark, for light backgrounds */
  logoOnLight: '/images/logo/krown1x-light.svg',
} as const;
